import { ErrorMessage } from "@/common/components";

export function NotFound() {
  return (
    <ErrorMessage
      title="Страница не найдена"
      description="Вернитесь назад или перейдите на главную страницу"
    />
  );
}
